module.exports = {
    "Clear search": `T\xf8m s\xf8k`
};


//# sourceMappingURL=nb-NO.main.js.map
